import React from "react";

import styles from "../../../styles/add-user.module.scss";

import { Button } from "../../components/Button";
import { Checkbox } from "../../components/Checkbox";
import { Drawer } from "../../components/Drawer";
import { Hairline } from "../../components/Hairline";
import { Input } from "../../components/Input";
import { InputSearch } from "../../components/InputSearch";
import { Label } from "../../components/Label";
import { Icon } from "../../components/core/Icon";

import { EnvironmentsAPI } from "@providers/EnvironmentsAPI";
import ROLES from "data/Roles";
import { UserStorage } from "../../../shared/tools/UserStorage";
import { Select } from "../../components/Select";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";

export default class AddUser extends React.Component {
  state = {
    brands: [],
    filteredBrands: [],
    openedBrands: [],
    selectedUserUnits: [],
    isSaving: false,
    user: {},
    error: null,
    showAllowedBrands: true,
    searchTerm: '',
  };

  async setAsyncState(data) {
    return new Promise((resolve) => this.setState(data, resolve));
  }

  get is_admin() {
    const userRole = UserStorage.getLoggedUser()?.role;

    return userRole == "ADMIN" || userRole == "SUPPORT";
  }

  get is_support() {
    const userRole = UserStorage.getLoggedUser()?.role;

    return userRole == "SUPPORT";
  }

  ROLE_OPTIONS = [
    { label: "Administrador", value: "ADMIN" },
    { label: "Lojista Franqueado", value: "MANAGER" },
    { label: "Lojista Operador", value: "SHOPKEEPER" },
    { label: "Marketing", value: "MARKETING" },
    { label: "SAC", value: "SAC" },
  ];

  componentDidMount() {
    const { user, selectedUserUnits, environment } = this.props;

    const hasSupportRole = this.ROLE_OPTIONS.some((r) => r.value === "SUPPORT");

    if (this.is_support && !hasSupportRole) {
      this.ROLE_OPTIONS.unshift({
        label: "Suporte",
        value: "SUPPORT",
      });
    } else
      this.ROLE_OPTIONS = this.ROLE_OPTIONS.filter(
        (r) => r.value !== "SUPPORT"
      );

    if (!this.is_admin) {
      this.ROLE_OPTIONS = this.ROLE_OPTIONS.filter(
        (r) => r.value !== ROLES.ADMIN
      );
    }

    const brands = this.generateUnits(selectedUserUnits);

    let newSelecteUserUnits = [];

    if (
      this.ROLE_OPTIONS[0]?.value === ROLES.ADMIN &&
      environment?.type === "BRAND"
    ) {
      this.setState({ showAllowedBrands: false });

      for (const brand of brands) {
        for (const unit of brand.units) {
          newSelecteUserUnits = [...newSelecteUserUnits, unit.id];
        }
      }
    } else {
      this.setState({ showAllowedBrands: true });
      newSelecteUserUnits = [];
    }

    this.setState({
      user,
      selectedUserUnits: user?.id ? selectedUserUnits : newSelecteUserUnits,
      brands: user?.id ? brands : this.generateUnits(newSelecteUserUnits),
      filteredBrands: user?.id ? brands : this.generateUnits(newSelecteUserUnits),
    });
  }

  allowUpdateBrands() {
    const { user } = this.state;
    const { environment } = this.props;
    const loggedUser = UserStorage.getLoggedUser();
    const isSameUser = user && user.id === loggedUser.user_id;
    const isBrandActive = environment?.type === "BRAND"
    return loggedUser.user_type !== "UNIT" && !isSameUser && !isBrandActive;
  }

  allowDeleteUser() {
    const userType = UserStorage?.getUserType();
    return userType === "HOLDING" || userType === "BRAND";
  }

  generateUnits(selectedUserUnits) {
    const { units } = this.props;

    const brands = {};
    for (const u of units) {
      const isUnitChecked = !!selectedUserUnits.find((i) => i == u.id);

      if (!brands[u.brand.alias]) {
        brands[u.brand.alias] = {
          ...u.brand,
          units: [{ ...u, checked: isUnitChecked }],
          checked: isUnitChecked,
        };
      } else {
        brands[u.brand.alias].units.push({ ...u, checked: isUnitChecked });
        brands[u.brand.alias].checked =
          brands[u.brand.alias].checked || isUnitChecked;
      }
    }

    return Object.values(brands);
  }

  onToggleShowUnits(id) {
    const { openedBrands } = this.state;
    this.setState({
      openedBrands: openedBrands.includes(id)
        ? openedBrands.filter((bId) => bId != id)
        : [...openedBrands, id],
    });
  }

  async onToggleUnitSelection(unitId) {
    const { selectedUserUnits } = this.state;

    let newSelecteUserUnits = [];
    if (selectedUserUnits.includes(unitId)) {
      newSelecteUserUnits = selectedUserUnits.filter((uId) => uId != unitId);
    } else {
      newSelecteUserUnits = [...selectedUserUnits, unitId];
    }

    this.setState({
      selectedUserUnits: newSelecteUserUnits,
      brands: this.generateUnits(newSelecteUserUnits),
      filteredBrands: this.generateUnits(newSelecteUserUnits),
    });
  }

  async selectAllUnits(units) {
    for (const unit of units) {
      await this.onToggleUnitSelection(unit.id);
    }
  }

  onChangeUserField(event, field) {
    const { brands } = this.state;

    if (field === "role") {
      const role = event.target.value;

      let newSelecteUserUnits = [];

      if (role === ROLES.ADMIN || role === ROLES.MARKETING) {
        brands.map((b) => {
          for (const unit of b.units) {
            newSelecteUserUnits = [...newSelecteUserUnits, unit.id];
          }
        });

        this.setState({
          selectedUserUnits: newSelecteUserUnits,
          brands: this.generateUnits(newSelecteUserUnits),
          filteredBrands: this.generateUnits(newSelecteUserUnits),
          showAllowedBrands: false,
        });
      } else {
        newSelecteUserUnits = [];
        this.setState({
          selectedUserUnits: newSelecteUserUnits,
          brands: this.generateUnits(newSelecteUserUnits),
          filteredBrands: this.generateUnits(newSelecteUserUnits),
          showAllowedBrands: true,
        });
      }
    }

    const { user } = this.state;
    this.setState({
      user: {
        ...user,
        [field]: event.target.value,
      },
    });
  }

  async onHandleSubmit() {
    const { environment } = this.props;

    try {
      const { onSave } = this.props;
      const { selectedUserUnits, user } = this.state;

      let environment_id = EnvironmentStorage.getSelectedEnvironment();
      if (user && user.environment_id) {
        environment_id = user.environment_id;
      }

      const isBrandActive = environment?.type === "BRAND"

      if (selectedUserUnits.length === 0 && !isBrandActive) {
        return alert({
          text: "O usuário deve ter ao menos uma unidade selecionada",
          buttonText: "Ok",
        });
      }

      const payload = {
        ...user,
        role: !user.role
          ? environment?.type === "BRAND"
            ? this.is_support
              ? ROLES.SUPPORT
              : ROLES.ADMIN
            : this.is_support
            ? ROLES.SUPPORT
            : ROLES.MANAGER
          : user.role,
        scopes: user?.scopes?.length ? user.scopes : ["USER_LIST"],
        environments: selectedUserUnits,
        configurations: {},
        environment_id,
      };

      if (!user.id) {
        await this.setAsyncState({ isSaving: true });
        const response = await EnvironmentsAPI.postUserByEnvironmentId(
          String(environment_id),
          payload
        );
        const errors = response.getErrors([]);
        if (errors.length > 0) {
          alert({ text: errors[0], buttonText: "Ok" });
        } else {
          await this.setAsyncState({ isSaving: false });
          onSave && onSave();
        }
        await this.setAsyncState({ isSaving: false });
      } else {
        await this.setAsyncState({ isSaving: true });
        const response = await EnvironmentsAPI.putUserByUserId(
          String(environment_id),
          user.id,
          payload
        );
        const errors = response.getErrors([]);
        if (errors.length > 0) {
          alert({ text: errors[0], buttonText: "Ok" });
        } else {
          await this.setAsyncState({ isSaving: false });
          onSave && onSave();
        }
        await this.setAsyncState({ isSaving: false });
      }
    } catch (err) {
      this.setAsyncState({ isSaving: false });
    }
  }

  validateFields() {
    const { user } = this.state;

    return !(
      user.name &&
      user.email &&
      user.username &&
      user.role &&
      user.password &&
      user.passwordConfirm
    );
  }

  async onDeleteUser() {
    const { onDelete } = this.props;
    const confirmResponse = await window.confirm({
      text: "Você realmente deseja excluir esse usuário?",
      confirmText: "Sim",
      cancelText: "Voltar",
    });

    if (confirmResponse) {
      const { user } = this.state;
      let environmentId = EnvironmentStorage.getSelectedEnvironment();
      if (user && user.environment_id) {
        environmentId = user.environment_id;
      }

      const deleteResponse = await EnvironmentsAPI.deleteUserByUserId(
        environmentId,
        user.id
      );
      const errors = deleteResponse.getErrors([]);
      if (errors.length > 0) {
        return alert({
          text: errors[0],
          buttonText: "Ok",
        });
      } else if (onDelete) {
        onDelete();
      }
    }
  }

  onSearch = (text) => {
    this.setState({ searchTerm: text });

    const { brands, openedBrands } = this.state

    const search = brands.map((c) => ({
      ...c,
      units: c.units.filter(
        (v) => v.name.toLowerCase().includes(text) || v.name.includes(text)
      ),
    })).filter((c) => c);

    let arr = []

    for (let i = 0; i < search.length; i++) {
      const brandId = search[i].id;
      arr.push(brandId)
    }

    this.setState({ openedBrands: [...arr] })

    if (text?.length === 0) {
      this.setState({ filteredBrands: brands });
      this.setState({ openedBrands: [] })
    } else {
      this.setState({ filteredBrands: search });
    }
  };

  render() {
    const { visible, onClose, environment } = this.props;
    const { user, isSaving, filteredBrands, openedBrands, showAllowedBrands } =
      this.state;

    const allowDeleteUser = this.allowDeleteUser();

    return (
      <Drawer
        visible={visible || isSaving}
        title={user.id ? "Editar usuário" : "Adicionar usuário"}
        onClose={() => onClose(false)}
      >
        <div className={styles.scrollContainer}>
          <Label design="two">Dados</Label>
          <form>
            <Input
              design="two"
              floatLabel="Nome"
              value={user.name}
              onChange={(value) => this.onChangeUserField(value, "name")}
              className="mb-20"
            />
            <Input
              design="two"
              floatLabel="Email"
              value={user.email}
              onChange={(value) => this.onChangeUserField(value, "email")}
              className="mb-20"
            />
            <Input
              floatLabel="Celular"
              design="two"
              value={user.phone}
              mask="(99) 99999-9999"
              type="tel"
              onChange={(value) => this.onChangeUserField(value, "phone")}
              className="mb-20"
            />
            <Input
              design="two"
              floatLabel="Nome de usuário"
              value={user.username}
              onChange={(value) => this.onChangeUserField(value, "username")}
              className="mb-20"
            />
            <Select
              design="two"
              floatLabel="Cargo"
              options={this.ROLE_OPTIONS.filter((o) => {
                let onlyBrand = [];
                if (environment?.type !== "BRAND")
                  onlyBrand = ["ADMIN", "MARKETING"];

                return !onlyBrand.includes(o.value);
              })}
              value={user.role}
              onChange={(value) => this.onChangeUserField(value, "role")}
              className="w-100 mb-20"
            />
            <Input
              floatLabel="Senha"
              design="two"
              type="password"
              onChange={(value) => this.onChangeUserField(value, "password")}
              className="mb-20"
            />
            <Input
              floatLabel="Repetir senha"
              design="two"
              type="password"
              onChange={(value) =>
                this.onChangeUserField(value, "passwordConfirm")
              }
            />
          </form>

          {this.allowUpdateBrands() && showAllowedBrands && (
            <>
              <Hairline />

              <Label design="two">Marcas permitidas</Label>
              <InputSearch
                placeholder="Buscar por unidade"
                value={this.state.searchTerm}
                onChange={(e) => this.onSearch(e.target.value)}
              />

              <div className={styles.brands}>
                {filteredBrands.map((brand, index) => {
                  return (
                    <div className={styles.brand} key={index}>
                      <div
                        className={`${styles.header} ${
                          brand.checked ? styles.show : styles.hide
                        }`}
                        onClick={() => this.onToggleShowUnits(brand.id)}
                      >
                        <Checkbox
                          checked={brand.checked}
                          onChange={() => this.selectAllUnits(brand.units)}
                        >
                          {brand.name}
                        </Checkbox>
                        <div className="d-flex align-center">
                          <span className={styles.numberUnits}>
                            {brand.units.length}
                          </span>
                          <Icon name="chevron-down" size="sm" />
                        </div>
                      </div>

                      {openedBrands.includes(brand.id) && brand.units.length > 0 && (
                        <div className={styles.units}>
                          {brand.units.map((unit, unitIndex) => (
                            <Checkbox
                              className="mb-15"
                              checked={unit.checked}
                              onChange={() =>
                                this.onToggleUnitSelection(unit.id)
                              }
                              key={unitIndex}
                            >
                              {unit.name}
                            </Checkbox>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        <div className={styles.footer}>
          <div className="d-flex">
            <Button
              design="primary"
              className="flex-1"
              onClick={this.onHandleSubmit.bind(this)}
              loading={isSaving}
              disabled={isSaving}
            >
              Salvar
            </Button>
            {user.id && allowDeleteUser && (
              <Button
                className={"ml-10"}
                onClick={this.onDeleteUser.bind(this)}
              >
                <Icon name="trash-alt" size="1x" />
              </Button>
            )}
          </div>
        </div>
      </Drawer>
    );
  }
}
